module.exports = __webpack_public_path__ + "img/plus.bdcb7636.svg";